module.exports = __webpack_public_path__ + "static/media/logo-zurich_new.d1e1c9e2.svg";